import { Button } from "@components/buttons/button";
import { Card } from "@components/cards/card";
import {
  IRaffleDefaultDTO,
  IRaffleDefaultStatusDTO,
} from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { IRaffleTicketFilter, RaffleStatusTypes } from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { FiCheckSquare, FiEye } from "react-icons/fi";
import { getRaffleStatus } from "@hooks/functions/Raffle/status";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import Skeleton from "react-loading-skeleton";
import { InputClickToCopy } from "@components/forms/input-click-to-copy";
import { useSearchParams } from "react-router-dom";
import { api } from "@service/api";
import { RaffleDefaultNumberRewardList } from "../number/rewardList";
import { RaffleDefaultNumberFloatOfferBox } from "../number/floatOfferBox";
import { getTicketRandomly } from "@hooks/functions/Raffle/general";
import { Masks } from "@hooks/functions/Masks/Masks";
import { FaShareFromSquare } from "react-icons/fa6";

interface IPriceValues {
  priceGross: number;
  discount: number;
  price: number;
}

export function RaffleDefaultWord() {
  // Main PlugIns, Attr, etc...
  const masks = new Masks();
  const { customer } = ZuAuthStore();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // Configs & Rules
  const ticketsForRow = 5;
  const pageConfig = {
    raffle: {
      id: "test-iphone-netflix",
      key: "ZVBaWg",
      type: "default_word",
    },
  };
  const [searchParams] = useSearchParams();
  const campaign = searchParams.get("campaign");
  const shareLink = `${window.location.href}`;

  const [raffle, setRaffle] = useState<IRaffleDefaultDTO>();
  const [raffleStatus, setRaffleStatus] = useState<IRaffleDefaultStatusDTO>({
    status: "x",
    text: "Carregando...",
    title: "Carregando...",
    color: "warning",
  });

  // Filters
  const [ticketFilter, setTicketFilter] = useState<IRaffleTicketFilter>("e");
  const [selectedTickets, setSelectedTickets] = useState<string[]>([]);

  // Tickets
  const [availableTicketAmount, setAvailableTicketAmount] = useState<number>(0);
  const [soldProgress, setSoldProgress] = useState<number>(0);

  // Visibilities
  const [showCampaignInfo, setShowCampaignInfo] = useState<boolean>(false);

  const [priceValues, setPriceValues] = useState<IPriceValues>({
    priceGross: 0,
    discount: 0,
    price: 0,
  });

  function sendToastifyMessage(message: string) {
    pushToastify({
      message,
      type: "info",
      theme: "dark",
    });
  }

  function onClickTicket(ticket: string) {
    setSelectedTickets((prev) =>
      prev.includes(ticket)
        ? prev.filter((item) => item !== ticket)
        : [...prev, ticket]
    );
  }

  function updatePriceValues() {
    const raffleUnitPrice: number = raffle?.price || 0;
    const priceGross: number = raffleUnitPrice * (selectedTickets.length || 0);
    const discount: number = 0;
    const price: number = priceGross - discount;

    setPriceValues((prev) => ({
      ...prev,
      priceGross: priceGross,
      discount,
      price,
    }));
  }

  function buyTicket() {
    sendToastifyMessage(
      "Esta opção não está disponível nesta página e para esta Campanha."
    );
  }

  const actionButtons = (ticket: string) => {
    return (
      <>
        <div className="w-100">
          <label className="btn btn-info w-100 d-flex align-items-center justify-content-center">
            <input
              type="checkbox"
              className="me-2"
              checked={selectedTickets.includes(ticket)}
              onChange={() => onClickTicket(ticket)}
            />
            Selecionar
          </label>
        </div>
        <div className="w-100">
          <Button
            type="button"
            className="btn btn-success py-2 w-100"
            onClick={() => buyTicket()}
          >
            Comprar
          </Button>
        </div>
      </>
    );
  };

  const loadTicketFilter = () => {
    return (
      <>
        {raffle?.ticketData &&
          raffle?.ticketData
            .filter((item) => {
              if (ticketFilter === "e") return true;
              if (ticketFilter === "a") return !item?.clientData?.atSign;
              if (ticketFilter === "m")
                return customer?.customer?.atSign
                  ? item?.clientData?.atSign === customer?.customer?.atSign
                  : false;
              if (ticketFilter === "u") return item?.clientData?.atSign;
              return true;
            })
            .map((item, index) => (
              <div
                key={index}
                className="mb-2"
                style={{ flex: `0 0 ${100 / ticketsForRow}%` }}
              >
                <Card className={`${index}`}>
                  <div className="card-header pb-2">
                    <div className="d-flex flex-column text-center">
                      <div className="h5 fw-bold pb-0 mb-0">{item?.ticket}</div>
                      <div className="fw-bold">{`${
                        Number(item?.order) < 10 ? `0` : ``
                      }${masks.formatMilhar(Number(item?.order))}`}</div>
                    </div>
                  </div>
                  <div className="card-body" style={{ minHeight: "75px" }}>
                    <div className="d-flex flex-column flex-md-row justify-content-center gap-2 w-100">
                      {item?.clientData?.atSign ? (
                        <span className="h5">{`@${item?.clientData?.atSign}`}</span>
                      ) : (
                        <>{actionButtons(item?.ticket)}</>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
            ))}
      </>
    );
  };

  const loadRaffleSoldProgress = () => {
    const totalTickets: number = raffle?.ticketData?.length || 0;
    const soldTickets: number =
      raffle?.ticketData?.filter((ticket) => ticket?.clientData).length || 0;
    const progress = Math.floor((soldTickets / totalTickets) * 100) || 0;
    setAvailableTicketAmount(Number(totalTickets - soldTickets) || 0);
    setSoldProgress(progress);
  };

  const setCampaignInfoVisibility = () => {
    setShowCampaignInfo(!showCampaignInfo);
  };

  const autoSelectAmount = (amount: number) => {
    const availableTickets: string[] = [];
    raffle?.ticketData?.map((ticket) => {
      if (!ticket?.clientData) availableTickets.push(ticket.ticket);
    });

    let randomTickets: string[] = [];
    if (availableTickets.length > 0) {
      randomTickets = getTicketRandomly(availableTickets, amount);
    }

    setSelectedTickets(randomTickets);
  };

  async function getCampaignInfo() {
    try {
      const params = `?campaign=${campaign}&key=${pageConfig.raffle.key}`;
      const response = await api.get(`/raffle/basicInfo${params}`);
      console.log({f: "GetCampaignInfo", params, response});

      if (
        !response?.data?.type ||
        response?.data?.type !== pageConfig.raffle.type
      ) {
        return sendToastifyMessage(
          `Esta campanha não pode ser carregada nesta página.`
        );
      }

      setRaffle(response?.data);
    } catch (error: any) {
      pushToastify({
        message:
          error?.response?.data?.message ||
          `Houve um erro ao identificar ou carregar as informações.`,
        type: "error",
        theme: "dark",
      });
    }
  }

  useEffect(() => {
    if (!campaign || campaign !== pageConfig.raffle.id) {
      return sendToastifyMessage(
        `A campanha não foi identificada ou não pode ser carregada nesta página, por favor, tente um link válido.`
      );
    }

    getCampaignInfo();
  }, []);

  useEffect(() => {
    loadRaffleSoldProgress();

    setRaffleStatus(
      getRaffleStatus(raffle?.status as RaffleStatusTypes)
    );
  }, [raffle]);

  useEffect(() => {
    loadTicketFilter();
  }, [ticketFilter]);

  useEffect(() => {
    updatePriceValues();
  }, [selectedTickets]);

  return (
    <>
      {/* Campaign Informations */}
      <Card>
        <div
          className="card-header py-2 d-flex flex-column justify-content-center align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setCampaignInfoVisibility();
          }}
        >
          <div className="card-title">Informações da Campanha</div>
          <div className="card-category fw-bold">
            Clique para ver {showCampaignInfo ? `menos` : `mais`}
          </div>
        </div>
        <div className={`card-body ${showCampaignInfo ? `` : `d-none`}`}>
          <div className="row">
            {!raffle ? (
              <>
                <Skeleton count={2} />
              </>
            ) : (
              <>
                <div className="col-md-12 d-flex flex-column text-center">
                  <span className="h5">{raffle?.name || "Sem nome"}</span>
                  <span className="h6 mb-0 pb-0">{`${raffle?.customerData?.name}`}</span>
                  <span className="h6">{`@${raffle?.customerData?.atSign}`}</span>
                </div>
                <div className="col-md-12 text-center my-3">
                  {raffle?.description_short || "Sem descrição curta..."}
                </div>
                <hr />
                <div className="col-md-12 mt-3">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: raffle?.description || `Sem descrição`,
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </Card>

      {/* Campaign Status */}
      <Card>
        <div className="card-header">
          <div className="text-center">
            <div className="card-title">Status da Campanha</div>
          </div>
        </div>
        <div className="card-body">
          {!raffle ? (
            <>
              <Skeleton count={3} />
            </>
          ) : (
            <>
              <div className="row d-flex flex-column gap-4 mb-4">
                {/* Campaign Status */}
                <div className="col-10 mx-auto text-center">
                  <div className="d-flex justify-content-center align-items-center">
                    <span
                      className={`rounded-circle d-inline-block me-2 bg-${raffleStatus?.color}`}
                      style={{ width: 15, height: 15 }}
                      title={raffleStatus?.title}
                    ></span>
                    <span>{raffleStatus?.text}</span>
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="col-10 mx-auto text-center">
                  <span className="fw-bolder">
                    {soldProgress}% dos tickets já foram vendidos.
                  </span>
                  <ProgressBar
                    now={soldProgress}
                    label={`${soldProgress}%`}
                    variant="primary"
                    animated
                  />
                </div>

                {/* Share this Campaign */}
                <div className="col-10 mx-auto">
                  <div className="mb-3 text-center">
                    <FaShareFromSquare className="fs-5 me-1" />
                    <InputClickToCopy
                      label="Link de Compartilhamento"
                      value={shareLink}
                      // animated
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Card>

      {/* The Rewards */}
      {raffle?.rewardData && (
        <RaffleDefaultNumberRewardList rewards={raffle?.rewardData} />
      )}

      {/* The Ticket Option Numbers */}
      <Card>
        <div className="card-header">
          <div className="text-center">
            <div className="card-title">Cartela de Tickets</div>
            <div className="card-category fw-bold">
              Total de Tickets: {raffle?.quantity}
            </div>
          </div>
        </div>
        <div className="card-body">
          {!raffle ? (
            <>
              <Skeleton count={3} height={25} />
            </>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-end align-items-center mb-2">
                  <div className="form-group">
                    <select
                      className="form-select"
                      aria-label="Filtro de Tickets"
                      onChange={(e) => autoSelectAmount(Number(e.target.value))}
                    >
                      <option value="0" selected>
                        Nenhum
                      </option>

                      {availableTicketAmount > 0 &&
                        [...Array(availableTicketAmount)].map((_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                    </select>
                  </div>
                  <FiCheckSquare
                    className="fs-4"
                    title="Escolher tickets aleatoriamente (escolha a quantidade desejada)."
                  />
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center mb-2">
                  <FiEye
                    className="fs-5"
                    title="Filtro de Tickets de Exibição."
                  />
                  <div className="form-group">
                    <select
                      className="form-select"
                      aria-label="Filtro de Tickets"
                      value={ticketFilter}
                      onChange={(e) =>
                        setTicketFilter(e.target.value as IRaffleTicketFilter)
                      }
                    >
                      <option value="e">Todos</option>
                      <option value="a">Disponíveis</option>
                      <option value="m">Meus Tickets</option>
                      <option value="u">Indisponíveis</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row d-flex flex">
                {/* Load Options */}
                {loadTicketFilter()}
              </div>
            </>
          )}
        </div>
      </Card>

      {campaign && (
        <RaffleDefaultNumberFloatOfferBox
          campaign={campaign}
          selectedTickets={selectedTickets}
          values={priceValues}
          visibilityStatus={selectedTickets.length > 0}
        />
      )}
    </>
  );
}
